import React from 'react';

type PaymentMethodButtonProps = {
  index: number;
  paymentMethod: string;
  selected: boolean;
  disabled: boolean;
  hasError: boolean;
  onClick: (paymentMethod: string) => void;
  className: string;
};

const PaymentMethodButton = ({
  index,
  paymentMethod,
  selected,
  disabled,
  hasError,
  onClick,
  className
}: PaymentMethodButtonProps): JSX.Element => {
  let buttonClass = selected
    ? ' product-card-button-selected cms-btn-toggle-selected'
    : ' product-card-button cms-btn-toggle-unselected';
  if (hasError) {
    buttonClass += ' has-error';
  }

  className += buttonClass;

  return (
    <button
      id={`btn-paymentmethod-${index}`}
      data-testid={`btn-paymentmethod-${index}`}
      className={className}
      disabled={disabled}
      onClick={() => onClick(paymentMethod)}>
      {paymentMethod}
    </button>
  );
};

export default PaymentMethodButton;
